define('home/mixins/asEmbedLayout',[
    'jquery',
    'underscore',

    'core/frameBus',
    'core/utils',
], function (
    $,
    _,

    FrameBus,
    coreUtils
) {
    'use strict';

    var asEmbedLayout = function () {
        var _events = this.events || {};
        this.events = _.extend({
            'click [data-action=close-drawer]': 'closeDrawer',
            'click .viewport': 'closeDrawerOnClick',
            'click [data-action=full-home]': 'openFullHome',
            'click [data-action=refresh-drawer]': 'handleRefresh',
            'keydown': 'handleKeyPress',

            // https://developer.mozilla.org/en-US/docs/Web/Events/wheel#Listening_to_this_event_across_browser
            'wheel .scrollable-measure-selector': 'handleScroll',
            'wheel .viewport': 'handleViewportScroll',
            'mousewheel .scrollable-measure-selector': 'handleScroll',
            'mousewheel .viewport': 'handleViewportScroll',
        }, _events);

        this.handleRefresh = function (evt) {
            evt.preventDefault();

            var elem = $(evt.currentTarget);
            elem.addClass('loading');

            var notifications = this.session.getOrCreateNotifications();
            var allUpdated = $.Deferred();
            var repliesUpdated = $.Deferred();

            $.when(allUpdated, repliesUpdated).done(function () {
                elem.removeClass('loading');
                notifications.all.trigger('clearUnreadCount');
            });

            notifications.all.fetchItems({
                reset: true,
                success: function () {
                    allUpdated.resolve();
                },
            });
            notifications.replies.fetchItems({
                reset: true,
                success: function () {
                    repliesUpdated.resolve();
                },
            });
        };

        this.openFullHome = function (evt) {
            evt.preventDefault();
            window.open(window.location.href, '_blank');
        };

        this.closeDrawerOnClick = function (evt) {
            // Don't close if user clicked somewhere in the home drawer
            // and not on the viewport directly
            if (!$(evt.target).hasClass('viewport'))
                return;

            this.closeDrawer(evt);
        };

        this.isIE10 = function () {
            return window.document.documentMode === 10;
        };

        this.handleKeyPress = function (evt) {
            if (evt.which === 27)
                this.closeDrawer(evt);
        };

        this.closeDrawer = function (evt) {
            evt.preventDefault();

            var body = $('body');
            body.removeClass('active');

            // this IE10 check is necessary to fix a bug where the css transitionend
            // event isn't called sometimes when the closing css transition completes.
            if (this.isIE10() || !coreUtils.transitionEndEvent) {
                _.delay(
                    _.bind(FrameBus.sendHostMessage, this, 'close'),
                    300
                );
            } else {
                body.one(coreUtils.transitionEndEvent, function () {
                    FrameBus.sendHostMessage('close');
                });
            }
        };

        var _onRender = this.onRender;
        this.onRender = function () {
            _onRender.apply(this, arguments);

            _.defer(_.bind(FrameBus.trigger, FrameBus, 'mainlayoutRendered'));
        };

        this.getScrollableContainer = function () {
            // if scrollableContainer isn't present or it doesn't have any parent due to
            // rerendering, we get the element again
            if (!this.scrollableContainer || !$.contains(window.document.documentElement, this.scrollableContainer[0]))
                this.scrollableContainer = this.$('.scrollable-measure-selector');

            return this.scrollableContainer;
        };

        this.handleViewportScroll = function (event) {
            event.preventDefault();
        };

        this.handleScroll = function (event) {
            var evt = event.originalEvent;

            // wheelDeltaY for mousewheel event - https://developer.mozilla.org/en-US/docs/Web/Events/mousewheel
            // deltaY for wheel event - https://developer.mozilla.org/en-US/docs/Web/Events/wheel
            var dir = evt.wheelDeltaY || -evt.deltaY;

            var scrollableContainer = this.getScrollableContainer();
            if (!scrollableContainer)
                return;

            // scrolled to top
            if (scrollableContainer.scrollTop() === 0 && dir > 0)
                event.preventDefault();

            // scrolled to bottom
            if ((scrollableContainer.scrollTop() + scrollableContainer.innerHeight() >= scrollableContainer[0].scrollHeight) && (dir < 0))
                event.preventDefault();

            // so it doesn't propagate to the viewport scroll event
            event.stopPropagation();
        };

    };

    return asEmbedLayout;
});

